import axios from "axios"
import config from "../../config"

const baseUrl = config.baseUrl

export async function getReporteAvancePlanOperativo() {
  try {
    const response = await axios.get(`${baseUrl}/api/reporteAvancePlanOperativo`, {
      maxBodyLength: Infinity,
    })
    return response.data
  } catch (error) {
    console.error("❌ Error al obtener el reporte:", error)
    throw error
  }
}
